(function () {
  'use strict';

  let currentInstance = null;
  let observerStarted = false;

  const ALLOWED_CHARS = /[^A-Za-z0-9À-ÖØ-öø-ÿ'’.,!?&\- ]/g;

  function tryInit() {
    const addon = document.getElementById('engraving-add-on');

    if (!addon) {
      currentInstance = null;
      return;
    }

    if (currentInstance && currentInstance.el === addon) {
      return;
    }

    currentInstance = new EngravingAddOn(addon);
  }

  function startObserver() {
    if (!document.body || observerStarted) return;

    observerStarted = true;

    const observer = new MutationObserver(function () {
      const addon = document.getElementById('engraving-add-on');

      if (addon && (!currentInstance || currentInstance.el !== addon)) {
        tryInit();
      }

      if (!addon && currentInstance) {
        currentInstance = null;
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  class EngravingAddOn {
    constructor(el) {
      this.el = el;

      this.config = {
        mode: (el.dataset.mode || 'size-gated').trim().toLowerCase(),

        qualifyingSizes: (el.dataset.qualifyingSizes || '75ml,100ml')
          .split(',')
          .map(function (size) {
            return size.trim().toLowerCase();
          })
          .filter(Boolean),

        maxLength: parseInt(el.dataset.maxLength, 10) || 18
      };

      this.els = {
        toggle: el.querySelector('#engraving-add-on-toggle'),
        panel: el.querySelector('#engraving-add-on-panel'),
        qualifierNotice: el.querySelector('#engraving-qualifier-notice'),
        qualifierText: el.querySelector('#engraving-qualifier-text'),
        field: el.querySelector('#engraving-field'),
        inputs: Array.from(
          el.querySelectorAll('.engraving-add-on__input')
        ),
        slots: Array.from(
          el.querySelectorAll('.engraving-add-on__slot')
        )
      };

      if (
        !this.els.toggle ||
        !this.els.panel ||
        !this.els.field ||
        !this.els.inputs.length
      ) {
        console.warn('Engraving add-on: required elements missing');
        return;
      }

      this.els.inputs.forEach((input) => {
        input.setAttribute(
          'maxlength',
          String(this.config.maxLength)
        );
      });

      this.bindEvents();
      this.updateAllCharCounts();
      this.watchVariantSelection();

      console.log(
        'Engraving add-on initialised',
        {
          mode: this.config.mode,
          inputs: this.els.inputs.length,
          qualifyingSizes: this.config.qualifyingSizes
        }
      );
    }

    bindEvents() {
      this.els.toggle.addEventListener('click', () => {
        this.togglePanel();
      });

      this.els.inputs.forEach((input) => {
        input.addEventListener('input', () => {
          this.onInput(input);
        });
      });

      this.els.slots.forEach((slot) => {
        const clearButton = slot.querySelector(
          '.engraving-add-on__clear'
        );

        const input = slot.querySelector(
          '.engraving-add-on__input'
        );

        if (clearButton && input) {
          clearButton.addEventListener('click', () => {
            this.clearInput(input);
          });
        }
      });

      document.addEventListener('variant:change', () => {
        this.updateAvailability();
      });

      document.addEventListener('variantChange', () => {
        this.updateAvailability();
      });
    }

    togglePanel() {
      const isOpen = !this.els.panel.hidden;

      this.els.panel.hidden = isOpen;

      this.els.toggle.setAttribute(
        'aria-expanded',
        String(!isOpen)
      );

      const icon = this.els.toggle.querySelector(
        '.engraving-add-on__toggle-icon'
      );

      if (icon) {
        icon.textContent = isOpen ? '+' : '−';
      }

      if (!isOpen) {
        this.updateAvailability();
      }
    }

    watchVariantSelection() {
      document.addEventListener('change', (event) => {
        if (
          event.target.matches('select') ||
          event.target.matches('input[type="radio"]') ||
          event.target.matches('input[name="id"]')
        ) {
          setTimeout(() => {
            this.updateAvailability();
          }, 100);
        }
      });

      setTimeout(() => {
        this.updateAvailability();
      }, 200);

      setTimeout(() => {
        this.updateAvailability();
      }, 700);

      setTimeout(() => {
        this.updateAvailability();
      }, 1500);
    }

    updateAvailability() {
      /*
        Gift sets configured as:
        |on|

        are always engravable.

        No size/variant checking is required.
      */

      if (this.config.mode === 'always-on') {
        this.showEngravingFields();
        return;
      }

      /*
        Standard fragrances and gated gift sets
        need their selected variant checked.
      */

      const variantLabel = this.getSelectedVariantLabel();

      const isQualifying =
        this.config.qualifyingSizes.some((size) => {
          return variantLabel.includes(size);
        });

      if (isQualifying) {
        this.showEngravingFields();
      } else {
        this.hideEngravingFields();
      }
    }

    getSelectedVariantLabel() {
      const form = this.getForm();

      if (!form) {
        return '';
      }

      const variantInput =
        form.querySelector('select[name="id"]') ||
        form.querySelector('input[name="id"]');

      /*
        If Shopify has a visible variant SELECT,
        use the selected option's label.
      */

      if (
        variantInput &&
        variantInput.tagName === 'SELECT' &&
        variantInput.selectedOptions &&
        variantInput.selectedOptions.length
      ) {
        return (
          variantInput.selectedOptions[0].textContent || ''
        )
          .trim()
          .toLowerCase();
      }

      /*
        Many themes use a hidden variant ID and
        separate radio/button selectors.

        Try the currently checked option selectors.
      */

      const checkedOptions = Array.from(
        form.querySelectorAll(
          'input[type="radio"]:checked'
        )
      );

      if (checkedOptions.length) {
        const labels = checkedOptions.map((radio) => {
          const associatedLabel =
            form.querySelector(
              'label[for="' + radio.id + '"]'
            );

          if (associatedLabel) {
            return associatedLabel.textContent.trim();
          }

          return (
            radio.value ||
            radio.getAttribute('data-value') ||
            ''
          );
        });

        return labels
          .join(' ')
          .trim()
          .toLowerCase();
      }

      /*
        Try selected custom option elements.
      */

      const selectedElements = form.querySelectorAll(
        [
          '[aria-checked="true"]',
          '.selected',
          '.is-selected',
          '[data-selected="true"]'
        ].join(',')
      );

      if (selectedElements.length) {
        return Array.from(selectedElements)
          .map(function (item) {
            return item.textContent || '';
          })
          .join(' ')
          .trim()
          .toLowerCase();
      }

      return '';
    }

    showEngravingFields() {
      if (this.els.qualifierNotice) {
        this.els.qualifierNotice.style.display = 'none';
      }

      if (this.els.field) {
        this.els.field.style.display = 'block';
      }

      this.setInputsEnabled(true);
    }

    hideEngravingFields() {
      if (this.els.qualifierNotice) {
        this.els.qualifierNotice.style.display = 'flex';
      }

      if (this.els.field) {
        this.els.field.style.display = 'none';
      }

      if (this.els.qualifierText) {
        const sizes = this.config.qualifyingSizes
          .map(function (size) {
            return size;
          })
          .join(' or ');

        this.els.qualifierText.textContent =
          'Please select a ' +
          sizes +
          ' size to add complimentary engraving.';
      }

      /*
        Disable inputs when engraving isn't allowed.

        Disabled form inputs are not submitted to Shopify,
        which prevents an engraving from accidentally being
        attached after switching from an eligible variant
        to an ineligible one.
      */

      this.setInputsEnabled(false);
    }

    setInputsEnabled(enabled) {
      this.els.inputs.forEach(function (input) {
        input.disabled = !enabled;
      });
    }

    onInput(input) {
      let cleaned = input.value.replace(
        ALLOWED_CHARS,
        ''
      );

      cleaned = cleaned.slice(
        0,
        this.config.maxLength
      );

      if (input.value !== cleaned) {
        input.value = cleaned;
      }

      this.updateCharCount(input);
    }

    clearInput(input) {
      input.value = '';
      this.updateCharCount(input);

      input.focus();
    }

    updateAllCharCounts() {
      this.els.inputs.forEach((input) => {
        this.updateCharCount(input);
      });
    }

    updateCharCount(input) {
      const slot = input.closest(
        '.engraving-add-on__slot'
      );

      if (!slot) return;

      const counter = slot.querySelector(
        '.engraving-add-on__char-count'
      );

      if (!counter) return;

      counter.textContent =
        input.value.length +
        ' / ' +
        this.config.maxLength;
    }

    getForm() {
      return (
        this.el.closest(
          'form[action*="/cart/add"]'
        ) ||
        document.querySelector(
          'form[action*="/cart/add"]'
        )
      );
    }
  }

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      tryInit();
      startObserver();
    }
  );

  if (document.readyState !== 'loading') {
    tryInit();
    startObserver();
  }

  setTimeout(tryInit, 800);
  setTimeout(tryInit, 2000);
})();